exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.flex[data-v-78fc0bae] {\n  display: flex;\n}\n.filter-option[data-v-78fc0bae] {\n  display: inline-block;\n  margin-left: 5px;\n  height: 45px\n}\n\n/* Doesn't have the desired effect, nor with:  ::v-deep  /deep/  >>>  */\n", ""]);

// exports
